require('jquery-validation');

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var ValidationHelpers = require('./validate-helpers');

var FORMS      = '.js-formValidateAjaxSubmit';

module.exports = function() {

    $(FORMS).each(function(){

        $FORM = $(this);

        $FORM.validate({

            // On Validation, submit the form
            submitHandler: function(form) {

                var $validatedForm = $(form);
                var ajaxAction = $validatedForm.attr('data-ajax-action');
                var formName = '#' + $validatedForm.attr('id');


                if (!ajaxAction) {
                    console.log('data-ajax-action missing.');
                    return;
                }

                ValidationHelpers.setLoading( $validatedForm, true);

                var formXHR = $.ajax({
                    url: ajaxAction,
                    type: "post",
                    data: $validatedForm.serialize()
                });


                formXHR.done(function(resp) {
                    if (typeof resp.success === 'undefined') {
                        // Out of bounds
                    }
                    else {
                        if (typeof resp.data.redirect !== 'undefined') {
                            window.location.href = resp.data.redirect;
                        }
                        ValidationHelpers.showMessage( $validatedForm, resp.data.message, resp.success);
                        $(formName).find('.form__submit').hide();
                    }

                });

                /*
                 * Ajax request failed, either in transport or the application threw a 500 error.
                 */
                formXHR.fail(function(jqXHR, textStatus, errorThrown) {
                    var appErrorMessage = JSON.parse(jqXHR.responseText).data.message;
                    if (!appErrorMessage) appErrorMessage = errorThrown;
                    ValidationHelpers.showMessage( $validatedForm, appErrorMessage, false);
                });


                formXHR.always(function(){
                    ValidationHelpers.setLoading( $validatedForm, false);
                })

            }

        });

        /*
         * This helper method prepares messages for the validator.
         * It MUST be loaded after the validator is loaded.
         */
        ValidationHelpers.loadFormMessages($FORM);

    });

}
